module.exports = __webpack_public_path__ + "static/media/michael.d0b4212e.jpg";